export function getAgentHubExperienceType(experience: App.ExperienceOffer) {
  if (!experience.productType) return 'experience'
  return {
    transfer: 'transfer',
    always_on: 'experience',
  }[experience.productType] || 'experience'
}
